import { Component } from "react";

// import PayementTotalBillCheque from "./PayementTotalBillCheque";
import PayementTotalBillEnLigne from "./PayementTotalBillEnLigne";
import PayementTotalBillEspece from "./PayementTotalBillEspece";
import PayementTotalBillVirement from "./PayementTotalBillVirement";
import PayementTotalBillChequeFN from "./PayementTotalBillChequeFN";
import PayementTotalBillWallet from "./PayementTotalBillWallet";
import PayementTotalBillEnLigneFN from "./PayementTotalBillEnLigneFN";
import PayementTotalBillEspeceFN from "./PayementTotalBillEspeceFN";
import PayementTotalBillVirementFN from "./PayementTotalBillVirementFN";
import PayementTotalBillPrelevementFN from "./PayementTotalBillPrelevementFN";

class MethodePayementBillTotal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      methodePayement: "",
    };
  }
  createUIPayement() {
    localStorage.setItem("restToPay", this.props.restToPay)
    if (this.state.methodePayement === "CHEQUE") {
      return <PayementTotalBillChequeFN />;
    } else if (this.state.methodePayement === "ENLIGNE") {
      return <PayementTotalBillEnLigneFN />;
    } else if (this.state.methodePayement === "ESPECE") {
      return <PayementTotalBillEspeceFN />;
    } else if (this.state.methodePayement === "VIREMENT") {
      return <PayementTotalBillVirementFN />;
    } else if (this.state.methodePayement === "PRELEVEMENT") {
      return <PayementTotalBillPrelevementFN />;
    } else if (this.state.methodePayement === "WALLET") {
      return <PayementTotalBillWallet />;
    }
  }
  handleChangePayement = (e) => {
    let payement = e.target.value;
    this.setState({
      methodePayement: payement,
    });
  };

  listOptionsPayement = () => {
    if (this.props.typeWallet) {
      return (
        <select class="form-control" onChange={this.handleChangePayement}>
          <option key={0} value={0}>
            Sélectionner un mode de payement
          </option>
          <option key={1} value={"ESPECE"}>
            Espèce
          </option>
          <option key={2} value={"ENLIGNE"}>
            En ligne
          </option>
          <option key={3} value={"CHEQUE"}>
            Chèques / Traites
          </option>
          <option key={4} value={"VIREMENT"}>
            Virement
          </option>
          <option key={5} value={"WALLET"}>
            Wallet
          </option>
          <option key={6} value={"PRELEVEMENT"}>
            Prélèvement
          </option>
        </select>
      );
    } else {
      return (
        <select class="form-control" onChange={this.handleChangePayement}>
          <option key={0} value={0}>
            Sélectionner un mode de payement
          </option>
          <option key={1} value={"ESPECE"}>
            Espèce
          </option>
          <option key={2} value={"ENLIGNE"}>
            En ligne
          </option>
          <option key={3} value={"CHEQUE"}>
            Chèques / Traites
          </option>
          <option key={4} value={"VIREMENT"}>
            Virement
          </option>
          <option key={6} value={"PRELEVEMENT"}>
            Prélèvement
          </option>
        </select>
      );
    }
  };
  render() {
    return (
      <div className="card-body">
        <h5 className="card-title">Choisir le mode de payement </h5>
        <div class="row">
          <div class="col-2"></div>
          <div class="col-10">{this.listOptionsPayement()}</div>
        </div>

        {this.createUIPayement()}
        <br />
      </div>
    );
  }
}
export default MethodePayementBillTotal;
